import React, { useState, Fragment } from 'react';
import produce from 'immer';
import TimePicker from 'rc-time-picker';
import { SingleDatePicker } from 'react-dates';
import moment from "moment";
import ValidationError from "~/Components/Forms/ValidationError";
import TextTranslate, { TextTranslateString } from '../../../Components/TextTranslate/TextTranslate';
import { connect } from 'react-redux';

function TrainRow({ onChange, values, errors, type, ...props }) {

	const dateFocusInitialState = { from: false, to: false };
	const [dateFocused, setDateFocused] = useState(dateFocusInitialState);

	const defaultFields = {
		arrival_station: '',
		arrival_date: null,
		arrival_time: null,
		departure_station: '',
		departure_date: null,
		departure_time: null,
		comments: ''
	};

	let travelPoints = {
		to: 'Arrival',
		from: 'Departure',
	}

	const form = { ...defaultFields, ...values };

	const inputChanged = (e) => {

		const name = e.target.name;
		const value = e.target.value;

		const newForm = produce(form, (draft) => {
			draft[name] = value;
		});

		onChange(newForm);
	};

	const dateChanged = (value, field) => {
		onChange(produce(form, (draft) => {
			draft[field] = value;
		}));
	};

	const timeChanged = (value, key) => {
		onChange(produce(form, (draft) => {
			if (value.isValid()) {
				value.seconds(0);
				draft[key] = moment.utc(value);

			} else {
				draft[key] = null;
			}
		}));
	};

	const dateFocusChanged = (f, key) => {
		setDateFocused({ ...dateFocusInitialState, [key]: f.focused });
	}

	return (
		<div>
			{Object.keys(travelPoints).map((key, index) => (
				<Fragment key={`train_${travelPoints[key]}`}>
					<div className="flex-1">
						<label><TextTranslate name={`train-${travelPoints[key].toLowerCase()}-station`} fallback={`${travelPoints[key]} Station`} textOnly /></label>
						<input type="text"
							placeholder={`${travelPoints[key]} Location`}
							value={form[`${travelPoints[key].toLowerCase()}_station`]}
							name={`${travelPoints[key].toLowerCase()}_station`}
							onChange={inputChanged}
							className="form-control" />

						<ValidationError errors={errors} name={`train.${travelPoints[key].toLowerCase()}_station`} />
					</div>

					<div className="flex-gap mt-2">
						<div className="flex-1">
							<label><TextTranslate name={`train-${travelPoints[key].toLowerCase()}-date`} fallback={`${travelPoints[key]} Date`} textOnly /></label>
							<div className="d-flex flex-column">
								<SingleDatePicker
									readOnly={true}
									isRTL={props.currentLanguage?.rtl}
									placeholder={TextTranslateString("placeholder-date", "Date", props.currentLanguage, props.translations)}
									id={`${travelPoints[key].toLowerCase()}_date`}
									small={true}
									focused={dateFocused[travelPoints[key].toLowerCase()]}
									date={form[`${travelPoints[key].toLowerCase()}_date`] ? moment(form[`${travelPoints[key].toLowerCase()}_date`]).locale(props.currentLanguage.code) : undefined}
									onDateChange={(date) => dateChanged(date, `${travelPoints[key].toLowerCase()}_date`)}
									onFocusChange={(f) => dateFocusChanged(f, travelPoints[key].toLowerCase())}
									openDirection={'up'}
									keepOpenOnDateSelect={false}
									hideKeyboardShortcutsPanel={true}
									numberOfMonths={1}
									monthFormat='MMM YYYY'
									displayFormat='ddd DD MMM'
									renderMonthElement={({ month }) => moment(month).locale(props.currentLanguage.code).format('MMMM YYYY')}
									renderDayContents={(day) => moment(day).locale(props.currentLanguage.code).format('D')}
								/>

								<ValidationError errors={errors} name={`train.${travelPoints[key].toLowerCase()}_date`} />
							</div>
						</div>

						<div className="flex-1">
							<label><TextTranslate name={`train-${travelPoints[key].toLowerCase()}-time`} fallback={`${travelPoints[key]} Time`} textOnly /></label>
							<TimePicker
								className="d-block"
								popupClassName="timepicker-neom"
								onChange={(time) => timeChanged(time, `${travelPoints[key].toLowerCase()}_time`)}
								defaultValue={form[`${travelPoints[key].toLowerCase()}_time`]}
								showSecond={false}
								placeholder={`${travelPoints[key]} Time`}
							/>

							<ValidationError errors={errors} name={`train.${travelPoints[key].toLowerCase()}_time`} />
						</div>
					</div>

					{(index - 1) < Object.keys(travelPoints).length && <hr />}
				</Fragment>
			))}
		</div>
	)
}

const mapStateToProps = (state) => ({
	currentLanguage: state.translations?.currentLanguage,
	translations: state.translations?.translations,
});

export default connect(mapStateToProps)(TrainRow);